module.exports = __webpack_public_path__ + "static/social-media-2263815bd8177cfd773b7441cb3a3c0f.jpg";